// ระบบหลายภาษา — ใช้ได้กับทุก React root (navbar / sidebar / root / footer)
// เพิ่มคำแปล: แก้ไฟล์ใน src/site/locales/<ภาษา>.json
import React, { useEffect, useState } from 'react';
import th from './locales/th.json';
import en from './locales/en.json';
import lo from './locales/lo.json';
import my from './locales/my.json';
import ja from './locales/ja.json';
import vi from './locales/vi.json';

export const LANGS = [
  { code: 'th', short: 'TH', label: 'ไทย' },
  { code: 'en', short: 'EN', label: 'English' },
  { code: 'lo', short: 'LA', label: 'ລາວ' },
  { code: 'my', short: 'MM', label: 'မြန်မာ' },
  { code: 'ja', short: 'JP', label: '日本語' },
  { code: 'vi', short: 'VN', label: 'Tiếng Việt' },
];
export const DEFAULT_LANG = 'th';
const DICT = { th, en, lo, my, ja, vi };
// ใช้ key 'lang' ร่วมกับหน้าสมาชิก (member/*) ที่อ่าน localStorage.getItem('lang')
const STORAGE_KEY = 'lang';

function readSaved() {
  try {
    const q = new URLSearchParams(window.location.search).get('lang');
    if (q && DICT[q]) return q;
    const s = window.localStorage.getItem(STORAGE_KEY) || window.localStorage.getItem('site_lang');
    if (s && DICT[s]) return s;
  } catch (e) { /* ignore */ }
  return DEFAULT_LANG;
}

let current = readSaved();
const listeners = new Set();
try { document.documentElement.lang = current; } catch (e) { /* ignore */ }

export function getLang() { return current; }

// ชื่อเว็บจาก API (mainsetting) — ข้อความที่มี {site} จะถูกแทนด้วยชื่อนี้
let siteName = '';
export function getSiteName() { return siteName; }
export function setSiteName(name) {
  const n = String(name || '').trim();
  if (!n || n === siteName) return;
  siteName = n;
  listeners.forEach((fn) => fn(current));
}

// ใช้ใน class component: this.unsub = subscribeLang((lang) => this.setState({ lang }))
export function subscribeLang(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function setLang(code) {
  if (!DICT[code] || code === current) return;
  current = code;
  try { window.localStorage.setItem(STORAGE_KEY, code); } catch (e) { /* ignore */ }
  document.documentElement.lang = code;
  listeners.forEach((fn) => fn(code));
}

function lookup(dict, key) {
  return key.split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), dict);
}

// t('menu.slot') -> ข้อความตามภาษาปัจจุบัน (ถ้าไม่มีใช้ภาษาไทย, ถ้าไม่มีอีกคืน key)
export function t(key, lang = current) {
  let v = lookup(DICT[lang], key);
  if (v === undefined) v = lookup(DICT[DEFAULT_LANG], key);
  if (v === undefined) return key;
  return typeof v === 'string' ? v.split('{site}').join(siteName) : v;
}

// Hook สำหรับ function component
export function useLang() {
  const [lang, setL] = useState(current);
  const [site, setSite] = useState(siteName);
  useEffect(() => {
    const fn = (l) => { setL(l); setSite(siteName); };
    listeners.add(fn);
    fn(current);
    return () => listeners.delete(fn);
  }, []);
  return { lang, site, setLang, t: (key) => t(key, lang) };
}

// ใช้ใน class component: <T k="nav.login" />
export function T({ k }) {
  const { t: tr } = useLang();
  return <>{tr(k)}</>;
}
